import { createContext } from 'react';

const useCallPerformanceContext = createContext();
export default useCallPerformanceContext;
